import { render, staticRenderFns } from "./ModalPhoto.vue?vue&type=template&id=244ccbf0&"
import script from "./ModalPhoto.vue?vue&type=script&lang=js&"
export * from "./ModalPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports